"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasurementInfoMobile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const react_i18next_1 = require("react-i18next");
const typography_1 = require("../../shared/typography");
const getUnit = (key, unitOfWeight, unitsOfLength) => {
    switch (key) {
        case "height":
            return unitsOfLength.main;
        case "weight":
            return unitOfWeight;
        default:
            return unitsOfLength.sub;
    }
};
const MeasurementInfoMobile = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const translations = t("measurement.overview.characteristics", {
        returnObjects: true
    });
    return ((0, jsx_runtime_1.jsx)(Wrapper, { children: Array.from(Object.entries(translations)).map(([key, value]) => {
            return ((0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: value }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: `${props[key]} ${getUnit(key, props.unitOfWeight, props.unitsOfLength)}` }, void 0)] }, key));
        }) }, void 0));
};
exports.MeasurementInfoMobile = MeasurementInfoMobile;
const Wrapper = styled_components_1.default.ul `
  margin-top: 1rem !important;

  li {
    align-items: center;
    display: flex;
    justify-content: space-between;

    p {
      color: ${({ theme }) => theme.colors.greyBase};
      font-weight: 500;
      line-height: 1.5rem;
      margin-bottom: 0;
    }

    p + p {
      color: ${({ theme }) => theme.colors.greyLighten40};
      font-weight: 400;
    }
  }
`;
//# sourceMappingURL=MeasurementInfoMobile.js.map